export default __webpack_public_path__ + "static/media/game.fc12b08d.png";